import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Dry-run preview of what `toteHandoffs[]` will be created if the picker
 * marks the given session as picked right now. Lets the picker UI render
 * a placement modal ("place tote X at zone Y") BEFORE actually completing
 * the session, so the picker physically deposits the totes first and
 * acknowledges before the split commits.
 *
 * Empty `handoffs` array = no continuations would be created; UI skips
 * the placement modal entirely.
 *
 * Pure read — does not mutate the session. The actual handoff split
 * happens on `markPickSessionAsPicked` and re-derives independently;
 * a race where another mutation slips in between preview and commit
 * just produces a slightly stale preview, never corrupt state.
 */
export const previewToteHandoffs = {
  name: "previewToteHandoffs" as const,
  input: z.object({ pickSessionId: zExt.objectId() }),
  output: z.object({
    handoffs: z.array(
      z.object({
        toteId: zExt.objectId(),
        toteName: z.string(),
        destinationZoneId: z.string(),
        destinationZoneName: z.string(),
        // Order this tote belongs to. The placement modal groups totes
        // by FG so multi-tote orders ("full totes" scenario) render as
        // a single block with a "place together" hint — the destination
        // picker must keep them adjacent.
        fulfillmentGroupId: z.string(),
      }),
    ),
  }),
};
